module.exports = __webpack_public_path__ + "img/imagen_guardas.d706f51e.png";